export default __webpack_public_path__ + "static/media/exporticon.5f3f29ce.svg";